import { FilingMethods } from '../../enums';

export const getIsReturnStatusEditable = ({
  filingMethod,
  efileStatus,
}: {
  filingMethod?: FilingMethods | null;
  efileStatus?: number | string | null;
}): boolean =>
  Boolean(
    filingMethod &&
      (filingMethod === FilingMethods.PAPER ||
        (filingMethod === FilingMethods.EFILE && !efileStatus)),
  );
